import React from 'react';
import { useApp } from '../context/AppContext';

/**
 * @param {{ moduleId: string }} props
 */
export function ComingSoon({ moduleId = 'records' }) {
  const { t } = useApp();

  const title = t(`comingSoon.${moduleId}.title`);
  const desc = t(`comingSoon.${moduleId}.desc`);
  const category = t(`comingSoon.${moduleId}.category`);
  const features = [1, 2, 3, 4]
    .map((i) => t(`comingSoon.${moduleId}.f${i}`))
    .filter((x) => typeof x === 'string' && x.length > 0 && !x.startsWith('comingSoon.'));

  return (
    <div className="coming-soon-page">
      <div className="coming-soon-page__hero coming-soon-page__hero--rich">
        <div className="coming-soon-page__hero-badges">
          <span className="coming-soon-page__badge coming-soon-page__badge--soon">{t('comingSoon.badge')}</span>
          <span className="coming-soon-page__badge coming-soon-page__badge--prep">{t('comingSoon.badgePrepared')}</span>
        </div>
        <span className="coming-soon-page__category">{category}</span>
        <h2 className="coming-soon-page__title">{title}</h2>
        <p className="coming-soon-page__lead">{desc}</p>
        <p className="coming-soon-page__value">{t('comingSoon.valueProposition')}</p>
        <p className="coming-soon-page__note">{t('comingSoon.preparedNote')}</p>
      </div>
      <div className="coming-soon-page__panel">
        <h2 className="coming-soon-page__panel-title">{t('comingSoon.featuresTitle')}</h2>
        <ul className="coming-soon-page__features">
          {features.map((f, idx) => (
            <li key={idx}>{f}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
